import {Controller} from "stimulus"
import $ from 'jquery';

export default class extends Controller {
    // Definimos los objetivos (targets) que vamos a usar en el HTML
    static targets = ["card", "radio", "btn"]

    // 1. Lógica de Selección (Cambio en Radio Button)
    // Se ejecuta automáticamente cuando el input type="radio" cambia
    select(event) {
        // Añadir clase al contenedor para activar el filtro gris en todos
        this.element.classList.add("has-selection")

        // Encontrar la tarjeta padre del radio que disparó el evento
        const selectedCard = event.target.closest(".shop-card")

        // Resetear: quitar 'is-selected' de todas las tarjetas
        this.cardTargets.forEach(card => {
            card.classList.remove("is-selected")
        })

        // Activar: añadir 'is-selected' solo a la actual
        if (event.target.checked && selectedCard) {
            selectedCard.classList.add("is-selected")
        }
    }

    // 2. Lógica de Disponibilidad (Clic en botón)
    checkAvailability(event) {
        const btn = event.currentTarget;
        const card = btn.closest(".shop-card");
        const radio = card.querySelector("input[type='radio']");

        event.preventDefault();
        event.stopPropagation();

        // Seleccionar la tarjeta temporalmente mientras carga
        radio.checked = true;
        radio.dispatchEvent(new Event('change'));

        if (btn.dataset.checked === "true") return;

        // Cargando...
        const originalText = btn.textContent;
        btn.textContent = "Consultando...";
        btn.disabled = true;

        setTimeout(() => {
            const hasStock = Math.random() > 0.3;

            if (hasStock) {
                // --- Lógica SI HAY STOCK (Igual que antes) ---
                card.classList.add("shop-card-available");
                card.classList.remove("is-selected");
                btn.textContent = "Reservar";
                btn.classList.add("is-reserve");
                btn.classList.remove("shop-primary");
                btn.disabled = false;
            } else {
                // --- Lógica SI ESTÁ AGOTADO (NUEVO COMPORTAMIENTO) ---

                // 1. Desmarcar el radio button
                radio.checked = false;

                // 2. Deshabilitar el input para que no se pueda volver a seleccionar
                radio.disabled = true;

                // 3. Disparar evento 'change' para que el controlador limpie la clase 'is-selected'
                //    (Esto quita el borde azul de selección)
                radio.dispatchEvent(new Event('change'));

                // 4. Añadir clase de 'deshabilitado' a la tarjeta (CSS)
                card.classList.add("is-disabled");

                // 5. Estado del botón
                btn.textContent = "Agotado";
                btn.classList.add("is-out");
                btn.disabled = true;
            }

            btn.dataset.checked = "true";
        }, 1500);
    }
}